<template>
  <Callout
    v-if="showExpirationAlert"
    :showCloseButton="true"
    data-test="callout-expiration-alert"
    class="licence-expiration-alert"
    severity="warning"
    @closeCallout="onCloseAlert">
    {{ licenceExpirationMessage }}
  </Callout>
</template>

<script setup lang="ts">
import Callout from "frontcore/components/Callout.vue"
import useLicenceExpirationConfiguration from "frontcore/store/configurations/useLicenceExpirationConfiguration"
import { ref } from "vue"

const showExpirationAlert = ref(false)

const { isLicenceActive, licenceExpirationMessage } =
  useLicenceExpirationConfiguration()

showExpirationAlert.value = !isLicenceActive

const onCloseAlert = () => {
  showExpirationAlert.value = false
}
</script>

<style scoped>
.licence-expiration-alert {
  position: absolute;
  top: 20px;
  z-index: 1000;
  border-radius: 15px;
  @media (max-width: 768px) {
    left: 20px;
  }
  @media (min-width: 769px) and (max-width: 1024px) {
    left: 30%;
  }
  @media (min-width: 1025px) {
    left: 40%;
  }
}
</style>
